import {
  FormaDistribuicaoArrecadacaoEnum,
  PeriodoArrecadacaoEnum,
  TipoArrecadacaoEnum,
} from "features/arrecadacoes/enums";
import { ArrecadacaoForm } from "features/arrecadacoes/typings/form";
import { shouldShowValorInput } from "../components/FormValor";

function validateStep(form: ArrecadacaoForm, step: number, maxStep: number) {
  const isCriarFundoAndHasFundoContaId = !!form.tenantContaId;

  if (step === 0) {
    // Step Geral
    const isExtraAndHasAccount = form.extra && !!form.tenantContaId;
    const isMultipleMonths =
      form.periodoArrecadacaoId?.toLowerCase() ===
      PeriodoArrecadacaoEnum.VariosMeses.toLowerCase();
    const isMultipleMonthsAndDateSet =
      isMultipleMonths && !!form.dataFim && !!form.dataInicio;

    // Campos obrigatórios -> categoriaFinanceiraId e periodoArrecadacaoId
    // Se for extra, tem que ter número da conta selecionado (isExtraAndHasAccount || !form.extra)
    // Se for data personalizada, tem que especificar a data (isMultipleMonthsAndDateSet || !isMultipleMonths)
    return (
      !!form.categoriaFinanceiraId &&
      !!form.periodoArrecadacaoId &&
      (isExtraAndHasAccount || !form.extra) &&
      (isMultipleMonthsAndDateSet || !isMultipleMonths)
    );
  } else if (step === 1) {
    // Step Unidades
    //const isSingleUnidadeAndHasUnidadeId = form.formaDistribuicaoArrecadacaoId === FormaDistribuicaoArrecadacaoEnum.UnicaUnidade && !!form.tenantContaId;
    // const isGrupoUnidadeAndHasGrupoUnidadeId = form.formaDistribuicaoArrecadacaoId === FormaDistribuicaoArrecadacaoEnum.GrupoUnidades && !!form.tenantContaId;
    // const isConsumoAndHasTipoConsumoId = form.formaDistribuicaoArrecadacaoId === FormaDistribuicaoArrecadacaoEnum.Consumo && !!form.tenantContaId;

    // Campos obrigatórios -> formaDistribuicaoArrecadacaoId e processarAbatimento
    // Caso cobrança seja apenas uma unidade, destinoId é obrigatório
    // Caso cobrança seja um grupo de unidades, destinoId é obrigatório
    // Caso cobrança seja em sobre consumo, tipo do consumo é obrigatório
    const isSingleUnidade =
      form.formaDistribuicaoArrecadacaoId ===
      FormaDistribuicaoArrecadacaoEnum.UnicaUnidade;
    const isSingleUnidadeAndHasUnidade = isSingleUnidade && form.destinoId;

    const isGrupoUnidade =
      form.formaDistribuicaoArrecadacaoId ===
      FormaDistribuicaoArrecadacaoEnum.GrupoUnidades;
    const isGrupoUnidadeAndHasGrupo = isGrupoUnidade && form.destinoId;

    const isConsumo =
      form.formaDistribuicaoArrecadacaoId ===
      FormaDistribuicaoArrecadacaoEnum.Consumo;
    const isConsumoAndHasConsumo = isConsumo && form.tipoConsumoId;
    return (
      !!form.formaDistribuicaoArrecadacaoId &&
      (!isSingleUnidade || isSingleUnidadeAndHasUnidade) &&
      (!isGrupoUnidade || isGrupoUnidadeAndHasGrupo) &&
      (!isConsumo || isConsumoAndHasConsumo)
    );

    // Caso o tipo de distribuição da arrecadação seja consumo, haverão 3 steps, sendo o último apenas para
    // escolher se deverá ser criado um fundo com o valor arrecadado
  } else if (
    step === 2 &&
    form.formaDistribuicaoArrecadacaoId ===
      FormaDistribuicaoArrecadacaoEnum.Consumo
  ) {
    // Step Criar Fundo - Distribuição Arrecadação = Consumo
    // Se for criar fundo, o id da conta é obrigatório;
    return isCriarFundoAndHasFundoContaId;
    // Caso em que a distribuição da arrecadação não é do tipo consumo
  } else if (step === 2) {
    // Step Valor - Distribuição Arrecadação != Consumo
    const isSingleUnidade =
      form.formaDistribuicaoArrecadacaoId ===
      FormaDistribuicaoArrecadacaoEnum.UnicaUnidade;
    const hasValorInput = shouldShowValorInput(
      form.tipoArrecadacaoId as TipoArrecadacaoEnum
    );

    const isSingleUnidadeAndHasValor = isSingleUnidade && form.valor;
    // Caso não seja unidade única, tipoArrecadacaoId é obrigatório
    // Caso o tipo de arrecadação necessitar de um campo de valor, ele será obrigatório
    // Caso seja unidade única, o valor é obrigatório
    return (
      isSingleUnidadeAndHasValor ||
      (!!form.tipoArrecadacaoId &&
        (!hasValorInput || (hasValorInput && form.valor)))
    );
  } else if (step === 3) {
    // O step 3 (número 4 no modal) pode ter várias formas
    // Quando é fração, são obrigatórios fracaoId, arrecadar(%), exibir no boleto e se for criar fundo, o número da conta;
    // Quando é criar fundo, se for criar um fundo, então o id da conta é obrigatório
    // Quando é peso, são obrigatórios pesoId, exibir no boleto e se for criar fundo, o número da conta;
    // Quando é valor manual, é obrigatório que pelo menos uma unidade tenha um valor maior que 0;
    
    const isFracaoStep =
      form.tipoArrecadacaoId ===
        TipoArrecadacaoEnum.ValorObtidoPrevisaoOrcamentaria ||
      form.tipoArrecadacaoId === TipoArrecadacaoEnum.DespesaMesAnterior ||
      form.tipoArrecadacaoId === TipoArrecadacaoEnum.ValorTotalRateado;
    const isRateioStep =
      form.tipoArrecadacaoId === TipoArrecadacaoEnum.ValorObtidoRateioDespesa;
    const isCriarFundoStep =
      form.tipoArrecadacaoId === TipoArrecadacaoEnum.ValorIgualTodasUnidades ||
      form.tipoArrecadacaoId === TipoArrecadacaoEnum.ValorMetrosUnidade;
    const isPesoStep =
      form.tipoArrecadacaoId === TipoArrecadacaoEnum.ValorPorIndexador;
    const isValorManualStep = form.tipoArrecadacaoId === TipoArrecadacaoEnum.ValorDiferenteCadaUnidade;

    if (isFracaoStep) {
      return (
        !!form.fracaoId &&
        form.percentualRateio !== undefined &&
        isCriarFundoAndHasFundoContaId
      );
    }
    if (isCriarFundoStep) {
      return isCriarFundoAndHasFundoContaId;
    }
    if (isRateioStep) {
      return !!form.rateioId && form.percentualRateio !== undefined;
    }
    if (isPesoStep) {
      return (
        !!form.indexadorId &&
        isCriarFundoAndHasFundoContaId
      );
    }
    if (isValorManualStep) {
      
      const valoresManuais = form.valorManualUnidades ? Object.entries(form.valorManualUnidades) : [];

      return valoresManuais.some(([_, value]) => Number(value) > 0);
    }
  } else if (step === 4) {
    // O step 4 (número 5 no modal) é sempre o de fração, caso tenha.
    // São obrigatórios fracaoId, exibir no boleto e se for criar fundo, o número da conta;
    return (
      !!form.fracaoId &&
      isCriarFundoAndHasFundoContaId
    );
  }
  return false;
}

export default validateStep;
